import { useNavigate } from "react-router-dom";

export default function LoginModal({ open, onClose }) {
  const navigate = useNavigate();

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-xl shadow-xl w-[360px] p-6 text-center relative">

        {/* Close */}
        <button
          onClick={onClose}
          className="absolute right-3 top-3 text-gray-500 hover:text-black"
        >
          ✕
        </button>

        {/* Logo / Title */}
        <h2 className="text-xl font-semibold mb-2">Join the conversation</h2>

        <p className="text-sm text-gray-500 mb-6">
          Sign in or create an account to interact with posts.
        </p>

        {/* Create account */}
        <button
          onClick={() => navigate("/signup")}
          className="w-full bg-orange-600 text-white py-2 rounded-lg mb-3 hover:bg-orange-700"
        >
          Create an account
        </button>

        {/* Sign in */}
        <button
          onClick={() => navigate("/login")}
          className="w-full bg-gray-100 py-2 rounded-lg hover:bg-gray-200"
        >
          Sign in
        </button>
      </div>
    </div>
  );
}